<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 bg-gradient-default">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container pt-lg-md">
            <div class="row">
                <div class="col">
                    <span>
                        <form>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <input type="text" v-model="input.url" class="form-control" id="url" placeholder="https://somepropertysite.com/fancy">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <button v-on:click="saveUrl" class="btn btn-primary" type="button">Add Property</button>
                                </div>
                            </div>
                        </form>
                    </span>
                </div>
            </div>



           <div class="row">
               <div class="col-sm-4" v-for="property in properties.slice().reverse()">
                   
                    <b-card
                        :title="property.shortDescription"
                        :img-src="property.leaderImage"
                        img-alt="Image"
                        img-top
                        tag="article"
                        style="max-width: 20rem;"
                        class="mb-2"
                    >
                        <b-card-text>
                        {{property.description}}
                        </b-card-text>

                        <b-button :href="property.url" variant="primary">View {{property.sourceApplication}}</b-button>
                    </b-card>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    // get the stuff - use this id 53017bfa-56c9-4cfa-8075-6a87669f41ed
    
    export default {
        name: 'Secure',
        data() {
            return {
                properties: [],
                input: {
                    url: ""
                }  
            };
        },
        mounted() {
            this.$http.get('/property/' + this.$currentUser.accountGroup)
                .then(response => {
                    this.properties = response.data;
                })
                .catch(e => {
                    console.log("wotfuck " + e)
                });   
        },
        methods: {
            saveUrl() {
                    var bodyData = JSON.stringify(this.input);
                    this.$http.post('/property/' + this.$currentUser.accountGroup,bodyData)
                    .then(response => {
                        if (response.status == 200)
                        {
                            this.properties = response.data;
                        }

                    })
                    .catch(e => {
                        console.error("Ouchy : " + e);
                        localStorage.clear();
                        this.$router.replace(this.$route.query.redirect || '/login');
                    })
            }
        }
    }
</script>

<style>
</style>